// calibration.ts — engine calibration scales and constants.
//
// The volume (m²) degressivity grid is not here: it lives in the Supabase `margin_tiers` table and is
// injected into compute() via the VolumeGrid type (see pricing/volume-tiers.ts).

/** Base margin of the quote (60 %). Fallback when the volume grid has no tier. */
export const BASE_MARGIN = 0.6;

/**
 * Purchase-price slope under a client discount: PA falls by 2/3 of the discount rate
 * (PV × (1−r), PA × (1−r×⅔)). Caps the margin erosion on discounted lines.
 */
export const PA_SLOPE = 2 / 3;

/** Target PA share of a minimum flat fee (40 % margin ⇒ 60 % of the fee). */
export const PA_FLAT_FEE_PCT = 0.6;

/** Default margin on a service (install equipment, etc.): 50%. */
export const DEFAULT_SERVICE_MARGIN = 0.5;

/** Margin on waste disposal: 40%. */
export const WASTE_MARGIN = 0.4;

/** Margin on a color test: 40%. */
export const TEST_MARGIN = 0.4;

/** Margin on a color calibration: 40%. */
export const CALIBRATION_MARGIN = 0.4;

/** Minimum waste-disposal delivery fee (€) added to the per-kg cost. */
export const MIN_WASTE = 129;

/** Default price per m² of the waste disposal (editable on the quote). */
export const WASTE_PRICE_M2 = 1.5;

/** Site survey, a yes / no at a fixed price: sale and purchase. */
export const SURVEY_PV = 250;
export const SURVEY_PA = 100;

/** Project management daily rate (€/day). */
export const GP_DAY_RATE = 690;

/**
 * Default scrap coefficient by material nature (UPZ material PA). Scrap (cut/width loss)
 * marks up the gross purchase price → net PA = gross × (1 + coeff). Soft 30 %, rigid 50 %,
 * none 0 % (material not purchased). Supervisor-overridable; "manual" mode bypasses these defaults.
 */
export const DEFAULT_WASTE_COEFF: Readonly<Record<"flexible" | "rigid" | "none", number>> = {
  flexible: 0.3,
  rigid: 0.5,
  none: 0,
};
